var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.00006 16.0001L4.00016 16L4.00014 15.9999L4.00015 15.9999L4.00011 15.9999L4.00037 15.9996L4.00036 15.9996C1.79123 13.7905 1.79123 10.2088 4.00036 7.99964C6.2095 5.7905 9.79121 5.7905 12.0003 7.99964L12.0007 7.99998C14.2098 5.79119 17.7913 5.7913 20.0003 8.00032C22.2094 10.2095 22.2094 13.7912 20.0003 16.0003C19.9847 16.0159 19.969 16.0314 19.9532 16.0468L12 24L4.00006 16.0001Z","fill":"currentColor"}));
}

Heart.defaultProps = {"aria-hidden":"true","width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Heart;

Heart.default = Heart;
